import React from 'react';

import NaturalPrice from './NaturalPrice/NaturalPrice';
import DiscountValue from './DiscountValue/DiscountValue';
import MonthlyPrice from './MonthlyPrice/MonthlyPrice';



const PlanDetail = props => {
    return <div className="PlanCardPriceDetail">
        <div className="DiscountArea">
          <NaturalPrice price={props.naturalPrice} priceWithTax={props.naturalPriceWithTax} />
          <DiscountValue value={props.discountValue} valueWithTax={props.discountValueWithTax} />
        </div>
        <div className="DiscountPrice">
          <div className="DiscountItem">2年お約束割料金 / 月</div>
          <MonthlyPrice price={props.discountPrice} priceWithTax={props.discountPriceWithTax} />
        </div>
        <AD fourK={props.fourK} />
        <Labels smartValue={props.smartValue} homeDicount={props.homeDicount} />
      </div>;
  };

export default PlanDetail;

const AD = ({ fourK }) => {
  if (fourK === "HDD") {
    return (
      <div className="MonthlyPriceAd" >
        HDD付きで録画も簡単！
      </div>
    );
  }

  const fourKPrice = parseInt(fourK, 10);

  if (fourKPrice > 0) {
    return (
      <div className="MonthlyPriceAd" >
        {'+500円（税込550円）で4K 放送が視聴可能'}
      </div>
    );
  }

  return null;
};

const Labels = ({ smartValue, homeDicount }) => {
  if (!smartValue && !homeDicount) {
    return null;
  }

  return (
    <div className="SmartValue">
      {!!smartValue && (
        <>
          <span className="orange">auスマートバリュー対象</span>
          <span className="pink">UQ自宅セット割対象</span>
        </>
      )}
      {!!homeDicount && (
        <span className="blue">ソフトバンクおうち割対象</span>
      )}
    </div>
  );
};
